import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
// Read `tags` from the URL query and store it in localStorage so every page can access it.
try {
  const params = new URLSearchParams(window.location.search);
  const tagsParam = params.get('tags');
  const scanFromParam = params.get('scan_from');

  if (scanFromParam && String(scanFromParam).trim() !== '') {
    localStorage.setItem('scan_from', String(scanFromParam).trim());
  }

  if (tagsParam && String(tagsParam).trim() !== '') {
    localStorage.setItem('tags', tagsParam);
    const tagsArray = String(tagsParam).split(',').map((s) => s.trim()).filter(Boolean);
    localStorage.setItem('tags_array', JSON.stringify(tagsArray));
  } else {
    // If `tags` is not present or empty, remove any previously stored values.
    localStorage.removeItem('tags');
    localStorage.removeItem('tags_array');
  }
} catch (e) {
  // Ignore if URL parsing or storage fails (e.g., privacy mode), but log for debugging.
  // eslint-disable-next-line no-console
  console.error('Failed to parse tags from URL:', e);
}

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
